module.exports = __webpack_public_path__ + "img/logo-text.bb75220e.svg";